import clsx from 'clsx';
import {
  IShopifyFormattedProductIdDetails,
  IWoocomFormattedProductIdDetails,
} from '@Saral-Influencer-Marketing/saral-utils/dist/types';
import { formatCurrency } from '../../../../utils/global';

import CustomTooltip from '../../../common/CustomTooltip/CustomTooltip';
import TrashIcon from '../../../../assets/icons/trash-icon';
import styles from '../requestProductModal.module.css';

interface PreviewProductProps {
  product: IShopifyFormattedProductIdDetails | IWoocomFormattedProductIdDetails;
  displayPrice?: number;
  removeSelectedProduct: (id: number) => void;
  className?: string;
  defaultCurrency: string;
}

export function PreviewProduct({
  product,
  displayPrice,
  removeSelectedProduct,
  className = '',
  defaultCurrency,
}: PreviewProductProps) {
  return (
    <div className={clsx(`${styles.shipFreePreviewProductCard} list-item-margin-8 rounded`, className)}>
      <div className={styles.shipFreeLeftContainer}>
        <img src={product.image} alt={product.name} />
        <div className={styles.previewProductTitleContainer}>
          <h3>{product.name}</h3>
          <p>{formatCurrency(Number(displayPrice ?? product?.price), defaultCurrency)}</p>
        </div>
      </div>
      <div className={styles.shipFreeRightContainer}>
        <CustomTooltip title="Remove">
          <div
            role="button"
            tabIndex={0}
            onClick={() => removeSelectedProduct(product.id)}
            className={styles.previewProductRemoveButton}
          >
            <TrashIcon width={20} height={20} color="var(--icon-default)" />
          </div>
        </CustomTooltip>
      </div>
    </div>
  );
}
